import axiosBase from "../../utils/axios/axios";


export const getAtributosBien = async () => {
    try {
        const response = await axiosBase.get("Descripcion_bien/atributos_bien/");
        return response.data;
    } catch (error) {
        throw error
    }
}